import { faCirclePlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CyPlaylistIndex } from "./CyPlaylistIndex";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { usePlaylistMutations } from "../playlist/graphql/usePlaylistMutations";
import { Fab } from "../common/components/Fab";
import { PlaylistRoutePaths } from "../playlist/PlaylistRoutePaths";

interface Props {
  currentCrewIdentifier: string | undefined;
}

export function NewPlaylistFab({ currentCrewIdentifier }: Props) {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const playlistMutations = usePlaylistMutations();

  function createPlaylistAndOpen() {
    const identifierToCreate = playlistMutations.createPlaylist({
      crewId: currentCrewIdentifier,
    });
    navigate(PlaylistRoutePaths.toCarousel(identifierToCreate));
  }

  return (
    <Fab
      onClick={() => createPlaylistAndOpen()}
      data-cy={CyPlaylistIndex.ButtonAddPlaylist}
    >
      <FontAwesomeIcon icon={faCirclePlus} /> {t("playlist.index.addPlaylist")}
    </Fab>
  );
}
